<!--  -->
<template>
  <div class="collection">
          <van-empty
      v-if="!list.length>0"
      class="custom-image"
      :image="require('../../assets/icons/empty.png')"
      description="暂无收藏"
    />

    <van-card v-else
    v-for="(item,index) in list " :key="index"
    @click="toPage(item.ProductId)"
      :price="item.item.Price/100"
      :desc="item.category.Name"
      :title="item.item.Name"
      :thumb="JSON.parse(item.item.ImageList)[0]"
    >
    <template #num>
       {{item.AddTIme}}
    </template>
    </van-card>
  </div>
</template>

<script>
import { Card,Empty } from "vant";
import api from "../../api/collection"
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Card.name]: Card,
    [Empty.name]: Empty,
  },
  data() {
    //这里存放数据
    return {
        list:[],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
      toPage(id){
          this.$router.push({
              name:'product',
              query: {
                  id:id
              }
          })
      }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
      api.collectionList().then(res=>{
          if(res.status==0){
              this.list=res.result
              console.log(this.list)
          }
      })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less"  scoped>
.van-card{
    background: #fff;
    .van-card__content{
    justify-content: center;
}
}

</style>